import { render, staticRenderFns } from "./manual-allot.vue?vue&type=template&id=bfbd7e18&scoped=true"
import script from "./manual-allot.vue?vue&type=script&lang=ts"
export * from "./manual-allot.vue?vue&type=script&lang=ts"
import style0 from "./manual-allot.vue?vue&type=style&index=0&id=bfbd7e18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbd7e18",
  null
  
)

export default component.exports